import { http } from "@/lib/http";

export function fetchCampaignPages() {
  return http.get("/api/campaign-page").then((res) => res.data);
}
export function fetchCampaignPage(id) {
  return http.get(`/api/campaign-page/${id}`).then((res) => res.data);
}
export function addCampaignPage(payload) {
  return http.post("/api/campaign-page/add", payload).then((res) => res.data);
}
export function saveCampaignPage(payload) {
  return http.post("/api/campaign-page/save", payload).then((res) => res.data);
}
export async function deleteCampaignPage(id, imageUrl) {
  await http.post("/api/campaign-page/delete", { id });
  if (imageUrl) {
    try {
      await http.delete("/api/file/delete", { data: { s3Url: imageUrl } });
    } catch (error) {
      void error;
    }
  }
}
export function uploadCampaignPageFile(file) {
  const data = new FormData();
  let url;
  if (file.type.includes("image")) {
    url = "/api/image_upload/campaign-page";
    data.append("imageFile", file);
  } else if (file.type.includes("video")) {
    url = "/api/video_upload/campaign-page";
    data.append("videoFile", file);
  } else {
    url = "/api/file_upload/campaign-page";
    data.append("file", file);
  }
  return http
    .post(url, data, { headers: { "Content-Type": "multipart/form-data" } })
    .then((res) => res.data.imageUrl);
}
